import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
declare var $;
declare var alasql;
declare const heartland: any;
@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.page.html',
  styleUrls: ['./checkout.page.scss'],
})
export class CheckoutPage implements OnInit {
  loggeduser: any;
  id_subscriptions: any;
  first_name: any;
  last_name: any;
  address_1: any;
  address_2: any;
  city: any;
  state: any;
  zip: any;
  phone: any;
  id_user: any;
  total: any;
  disc: any;
  shipping: any;
  subtotal: any;
  mealspermonth: any;
  amofmelas: any;
  plan_name: any;
  gbCart: any
  tax: any;
  GlobalPayments: any;
  constructor(public router: Router) {
    this.first_name = "";
    this.last_name = "";
    this.address_1 = "";
    this.address_2 = "";
    this.city = "";
    this.state = "AL";
    this.zip = "";
    this.phone = "";
    this.total = 0;
    this.shipping = 6;
  }

  ngOnInit() {
    this.set_datos_iniciales();
    this.GlobalPayments = heartland();
  }

  remove(ix) {
    var gbtemp = []
    for (var i = 0; i < this.gbCart.length; i++) {
      if (i != ix) {
        gbtemp.push({
          id_meals: this.gbCart[i].id_meals,
          name: this.gbCart[i].name,
          image: this.gbCart[i].image,
          description: this.gbCart[i].description,
          price: this.gbCart[i].price,
          qty: this.gbCart[i].qty,
        })
      }
      if (i == (this.gbCart.length - 1)) {
        this.gbCart = gbtemp
        this.ampla();
        console.log(this.gbCart);
      }
    }
  }

  ionViewWillEnter() {
    this.gbCart = JSON.parse(localStorage.gbcart)
    this.ampla();
  }

  addless(ix) {
    for (var i = 0; i < this.gbCart.length; i++) {
      if (ix == this.gbCart[i].id_meals) {
        var q = +this.gbCart[i].qty - 1;
        if (q == 0 || q < 0) {
          this.remove(i)
        } else {
          this.gbCart[i].qty = +this.gbCart[i].qty - 1;
          //localStorage.setItem("cart" + localStorage.appid + Theme_id, JSON.stringify(gbCart))
          //$scope.doRefresh();
          //$rootScope.$emit("updateCart");
          this.ampla();
          break;
        }
      }
    }
  }

  addmore(ix) {

    for (var x = 0; x < this.gbCart.length; x++) {
      if (ix == this.gbCart[x].id_meals) {
        this.gbCart[x].qty = parseInt(this.gbCart[x].qty) + 1;
        console.log(this.gbCart)
        this.ampla();
        break;
      }
    }

  }

  btn_subscription(transactionId) {
    this.save_datos_iniciales();
    var params: any = this.get_data_obj();
    params.op = "insert_order";
    params.paymentReference = transactionId;
    $.get(localStorage.apiurl, params, (r) => {
      console.log(r);
      localStorage.lastinsertedsub = r;
      alert(" Your order will ship within 2 business days")
      this.router.navigate(['/independent']) //aqui yo se que va a otra ruta
    })
  };

  incart(ix) {

    var res = alasql('SELECT * FROM ? WHERE id_meals = "' + ix + '"', [this.gbCart]);
    if (res.length > 0) {
      return res[0].qty;
    } else {
      return 0;
    }

  }

  ampla() {
    var tot = 0;
    for (var i = 0; i < this.gbCart.length; i++) {
      tot = (parseFloat(this.gbCart[i].qty) * parseFloat(this.gbCart[i].price)) + tot;
      if ((this.gbCart.length - 1) == i) {
        this.subtotal = tot;
        this.tax = tot * 0.08875
        this.total = this.shipping + this.tax + this.subtotal;
      }
    }
  }

  get_token() {
    if (document.getElementById("payment-formcheckout").innerHTML != "") {
      return;
    }
    this.GlobalPayments.configure({
      publicApiKey: "pkapi_prod_CW9XPGqx4dHxPJ2RVB"
    });

    var formOptions = {};
    // Create Form
    const cardForm = this.GlobalPayments.creditCard.form("#payment-formcheckout", formOptions);

    cardForm.ready(() => {
      // console.log("Registration of all credit card fields occurred");
      // console.log(cardForm);
    });

    cardForm.on("token-success", (resp) => {
      // add payment token to form as a hidden input
      let token = resp.paymentReference;
      this.create_transaction_payment(token, cardForm.frames.submit.container);
      // btn-changename3
    });

    cardForm.on("token-error", (resp) => {
      // show error to the consumer
      console.error(resp);
      $("#loading-payment").hide();
      alert("Payment Error \nPlease try again.");
      cardForm.frames.submit.container.style.display = "block";
    });

    // field-level event handlers. example:
    cardForm.on("submit", "click", () => {
      // console.log("Submited");
      $("#loading-payment").show();
      cardForm.frames.submit.container.style.display = "none";
    });
  }

  create_transaction_payment(token, btnsubmit) {
    var params: any = this.get_data_obj();
    params.op = "pago_individual";
    params.token = token;

    console.log(params);

    $.ajaxSetup({
      timeout: 0
    });
    $.get(localStorage.apiurl, params, (r: any) => {
      console.log(r);

      if (!r.error && r.type == "charged") {
        document.getElementById("payment-formcheckout").innerHTML = "";
        this.btn_subscription(r["charged"]["transactionReference"]["transactionId"]);
      } else {
        $("#loading-payment").hide();
        alert("Payment Error \nPlease Try Again");
        btnsubmit.style.display = "block";
      }
    }).fail(function () {
      $("#loading-payment").hide();
      alert("Payment Error \nPlease Try Again");
      btnsubmit.style.display = "block"
    });
  }

  validar_inputs() {
    if (this.first_name == "") {
      alert("Fill up the form correctly check for blank spaces.");
      return false;
    }

    if (this.last_name == "") {
      alert("Fill up the form correctly check for blank spaces.");
      return false;
    }

    if (this.address_1 == "") {
      alert("Fill up the form correctly check for blank spaces.");
      return false;
    }

    if (this.city == "") {
      alert("Fill up the form correctly check for blank spaces.");
      return false;
    }

    if ($(".state").val() == "") {
      alert("Fill up the form correctly check for blank spaces.");
      return false;
    }

    if (this.zip == "") {
      alert("Fill up the form correctly check for blank spaces.");
      return false;
    }

    if (this.loggeduser == "") {
      alert("Fill up the form correctly check for blank spaces.");
      return false;
    }

    if (this.phone == "") {
      alert("Fill up the form correctly check for blank spaces.");
      return false;
    }

    return true;
  }

  get_data_obj() {
    return {
      id_plan: localStorage.id_plan,
      id_user: this.loggeduser,
      first_name: this.first_name,
      last_name: this.last_name,
      address_1: this.address_1,
      address_2: this.address_2,
      city: this.city,
      state:this.state,
      zip: this.zip,
      phone: this.phone,
      amofmeals: localStorage.mealspermonth,
      disc: localStorage.disc,
      subtotal: parseFloat(this.subtotal).toFixed(2),
      tax: parseFloat(this.tax).toFixed(2),
      total: parseFloat(this.total).toFixed(2),
      shipping: this.shipping,
      gbcart: JSON.stringify(this.gbCart)
    };
  }

  load_payment_form() {
    if (this.validar_inputs()) {
      this.get_token();
    }
  }

  save_datos_iniciales(){
    localStorage.loggeduser = this.loggeduser;
    localStorage.first_name = this.first_name;
    localStorage.last_name = this.last_name;
    localStorage.address_1 = this.address_1;
    localStorage.address_2 = this.address_2;
    localStorage.city = this.city;
    localStorage.zip = this.zip;
    localStorage.phone = this.phone;
    localStorage.state = this.state;
  }

  set_datos_iniciales(){
    if(localStorage.loggeduser){
      this.loggeduser = localStorage.loggeduser;
    }
    if(localStorage.first_name){
      this.first_name = localStorage.first_name;
    }
    if(localStorage.last_name){
      this.last_name = localStorage.last_name;
    }
    if(localStorage.address_1){
      this.address_1 = localStorage.address_1;
    }
    if(localStorage.address_2){
      this.address_2 = localStorage.address_2;
    }
    if(localStorage.city){
      this.city = localStorage.city;
    }
    if(localStorage.state){
      this.state = localStorage.state;
    }
    if(localStorage.zip){
      this.zip = localStorage.zip;
    }
    if(localStorage.phone){
      this.phone = localStorage.phone;
    }
  }
}
